<div class="content-main-container">
    <div class="card">
        <div class="card-title">
            {{ card?.title }}
        </div>
        <mat-divider></mat-divider>
        <div fxLayout="row wrap" fxLayoutAlign="center" class="chip_area">
            <mat-chip-list *ngFor="let t of card?.tags">
                <mat-chip [ngStyle]="chipStyle(card?.type)" selected>{{ t | translate }}</mat-chip>
            </mat-chip-list>
        </div>
        <div class="card-sentence">
            <span class="voice_area">
                {{ card?.contents }}
            </span>
        </div>
        <div class="card-footer">
            <span class="author_area">
                {{ card?.author }}
            </span>
        </div>
    </div>
    <div class="goback_btn">
        <button 
            (click)="goBack()"
            mat-raised-button 
            color="primary">
            <mat-icon>arrow_back</mat-icon>
            {{ gobackBtnLabel | translate }}
        </button>
    </div>
</div>